/** 
 *   订单及详情
 */
import { get } from '@/untils/js/axios.js'

// 为你推荐商品列表显示
export const getOrderRemGoodsList = params => get('/goods/recommend/index', params)
